/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();






/******** Navraj Code ***************/



/**************** Active Collection Menu ***************/


$('.collection-nav a').each( function(link){ 
  if (link.href == document.location.href) {   
    Element.addClassName(link, 'active'); 
  }; 
});

/********** Announcement Marque text js *******************/


window.addEventListener('load', function () {
	function go() {
		i = i < width ? i + step : 1;
		m.style.marginLeft = -i + 'px';
	}
	var i = 0,
		step = 3,
		space = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
	var m = document.getElementById('marquee');
	var t = m.innerHTML; //text
	m.innerHTML = t + space;
	m.style.position = 'absolute'; // http://stackoverflow.com/questions/2057682/determine-pixel-length-of-string-in-javascript-jquery/2057789#2057789
	var width = (m.clientWidth + 1);
	m.style.position = '';
	m.innerHTML = t + space + t + space + t + space + t + space + t + space + t + space + t + space + t + space + t + space;
	m.addEventListener('mouseenter', function () {
		step = 0;
	}, true);
	m.addEventListener('mouseleave', function () {
		step = 3;
	}, true);
	var x = setInterval(go, 50);
}, true);

/********** END Announcement Marque text js *******************/


/********** Announcement Slider js *******************/


$('#AnnouncementBar-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false, 
  speed: 4500,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});




/********** END Announcement Slider js *******************/

/********** Brands Logo Slider js *******************/


$('#brands-logo-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});




/********** END Brands Logo Slider js *******************/



/************ Signup Form Popup **************/


    $(".popup_signup").click(function(){
       $('.signup-popup-Nav').show();
    });
   /* $('.signup-popup-Nav').click(function(){
        $('.signup-popup-Nav').hide();
    }); */
    $('.popupCloseButton').click(function(){
        $('.signup-popup-Nav').hide();
    });


/***************** Custom Select Design *****************/

//TOGGLING NESTED ul
$(".drop-down .selected span").click(function() {
    $(".drop-down .options ul").toggle();
});

//SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
$(".drop-down .options ul li").click(function() {
    var text = $(this).html();
    $(".drop-down .selected span").html(text);
    $(".drop-down .options ul").hide();
}); 


//HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
$(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("drop-down"))
        $(".drop-down .options ul").hide();
});



/******** Footer Mobile View *********/

   if ($(window).width() <= '640') {
        $('.Ul-list-M').toggle();
        $('.H2-ToggleM').click(function(e) {
          e.preventDefault();
          if(!$(this).hasClass('open')) $(this).addClass('open'); else $(this).removeClass('open'); 
               	$(this).next().toggle('slide');
            });
    }
    else {
         $('.H2-ToggleM').off("click");    
    }




/************** Quick View ******/

$(".quick_view").click(function(){
  var quick_id =  $(this).attr('id');
 	 $("#"+quick_id).click(function(){   
       $('#product-'+quick_id).show();
     });
});

 /*$("#quick-view-1").click(function(){   
       $('#product-quick-view-1').show();
    });*/
  
    $('.cd-close').click(function(){
        $('.Product-quick-view').hide();
    });



/************** SHow More Team Page ***************/

 $(".show-more").click(function () {
        if($(this).prev(".text").hasClass("show-more-height")) {
            $(this).text("(Learn Less)");
        } else {
            $(this).text("(Learn More)");
        }

        $(this).prev(".text").toggleClass("show-more-height");
    });


  $(".join_career").click(function (){
    $('html, body').animate({
      scrollTop: $(".career-openings").offset().top
    }, 2000);
  });
       

 $(".show-moreBtn").click(function () {

        if($(this).prev(".text").hasClass("show-more-height")) {
            $(this).text("(Show Less)");
        } else {
            $(this).text("(Show More)");
        }

        $(this).siblings( ".text").toggleClass("show-more-height");
    });


/********** tabs Slider js *******************/


$('#fini-car-men').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0,
  speed: 2000,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
  ]
});

$('#fini-car-women').slick({
  slidesToShow: 4,
 slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0,
  speed: 2000,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
  ]
});

//$('#women').hide();

$('#men .slleft').click(function() {
  $('#fini-car-men').slick('slickPrev');
})

$('#men .slright').click(function() {
  $('#fini-car-men').slick('slickNext');
})

$('#women .slleft').click(function() {
  $('#fini-car-women').slick('slickPrev');
})

$('#women .slright').click(function() {
  $('#fini-car-women').slick('slickNext');
})

$('.fini-products-tabs').click(function() {
  	$('.fini-products-tabs').removeClass('fini-product-tabs-active');
  	$(this).addClass('fini-product-tabs-active');
	var fipt= $(this).attr('data-tab');
  	$('.fini-product-tabs-container-content').hide();
  	$('#'+fipt).show();
  	$('#fini-car-'+fipt).slick('refresh');
});


$('.fini-blog-post-grid').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0,
  speed: 2000,
  pauseOnHover: false,
  infinite: false,
  variableWidth: true,
  dots: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

$('.fini-blog-post-grid2').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0,
  speed: 2000,
  pauseOnHover: false,
  infinite: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});


var owl = jQuery('.main-slider-fixed.owl-carousel');
var owlOptions = {
            loop:true,
            nav:true,
            responsive:{
                0:{
                    items:2
                },
                600:{
                    items:3
                },
                1000:{
                    items:4
                }
            }
        };
if ( $(window).width() < 854 ) {
  	var owlActive = owl.owlCarousel(owlOptions);
} else {
  	owl.addClass('off');
}

$(window).resize(function() {
    if ( $(window).width() < 854 ) {
        if ( owl.hasClass('off') ) {
            var owlActive = owl.owlCarousel(owlOptions);
            owl.removeClass('off');
        }
    } else {
        if ( !owl.hasClass('off') ) {
            owl.addClass('off').trigger('destroy.owl.carousel');
            owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
        }
    }
});
/*jQuery('.main-slider-fixed.owl-carousel').owlCarousel({
    loop:true,
    //margin:10,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
});*/